<template>
    <!-- 
        Quick-fetching-card

        Props: 
            fetchingAPI: (Opcional, Default inherit)
                URL for table/data fetching

            header: (Opcional, Default inherit)
                Header title

            footer: (Opcional, Default empty)
                Footer content text
 
        Version 1.2
        It can be configured with props.

        Version 1.1
        Require jquery to ensure loading in case of F5

        Version 1.0
        Quick fetching card allow you to a fast setting up for any kind of content with data preload.
        
        @Version 1.0
        @Author Daniel Lepe
     -->
	<div id="ConfigsTable">
		<b-card :header="header" header-tag="header" :footer="footer" footer-tag="footer" no-body>
            <div class="text-center p-5" v-if="isLoading">
                <b-spinner variant="primary" />
            </div>
            <template v-else>
                <b-table responsive striped v-if="typeof fetchedData == 'object' && typeof fetchedData.length == 'number'" :fields="fieldsConfg" :items="fetchedData" >
                    <template #cell(descripcion)="data">
                        <strong>{{data.value}}</strong> <br>
                        <small>[{{data.item.clave}}]</small>
                    </template>
                    <template #cell(_)="data">
                        <ui-edit-auto-modal :handler="'define/source/configuraciones/' + data.item.id" :form-archetype="formArchetype" :refresh="reload" allow-delete="false"/>
                    </template>
                </b-table>
                <template v-else>
                    {{fetchedData}}
                </template>
                <div slot="footer">
                    <b-card-text class="text-right">
                        <b-button @click="reload()" variant="outline-primary" key="fa-refresh">
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                        </b-button>
                    </b-card-text>
                </div>
            </template>
		</b-card>
	</div>
</template>

<script>
let fetchedData = {},
    formArchetype = [
        {
            key: "id",
            type: 'hidden', // [hidden|number|price|phone|textarea|positivo|password|email]
        },
        {
            key: "clave",
            readonly: true,
        },
        {
            key: "descripcion",
            label: 'Descripción',
            readonly: true,
        },
        {
            key: "valor",
        }
    ],
    header = 'Quick Card Title',
    footer = null,
    fieldsConfg = [
        {key: 'descripcion'},
        {key: 'valor'},
        {key: '_'}
    ],
    fetchingAPI = 'configs/getall';

import _ from 'lodash'
import axios from 'axios'

export default {
	name: "ConfigsTable",
    props: {
        fetchingAPI: {
            type: String,
            default: () => { return fetchingAPI }
        },
        header: {
            type: String,
            default: () => { return header }
        },
        footer: {
            type: String,
            default: () => { return footer }
        }
    },
    data: () => {
        return {
            isLoading: false,
            fieldsConfg,
            fetchedData,
            formArchetype
        }
    },
    methods: {
        async reload(){
            this.isLoading = true
            await this.loadUp()
            this.isLoading = false
        },
        async loadUp(){
            try {
                let response = await axios.get(this.fetchingAPI)

                // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
                this.fetchedData = {}
                if(response.status){
                    this.fetchedData = response.data
                }
            } catch (error) {
                console.error(error)
            }
        }
    },
    mounted() {
        this.reload()
    }
};
</script>